import React from "react";
import { Table } from "react-bootstrap";
import "./BenefitsTable.css";

function BenefitsTable() {
  const tableData = [
    { benefit: "Expert Inputs", combo: true, fallback: "RW Only" },
    { benefit: "ATS-compliant Profiles", combo: true, fallback: "RW Only" },
    { benefit: "Top Recruiter Search Results", combo: true, fallback: "FP Only" },
    { slab: true, benefit: "Guaranteed Visibility to Recruiters", combo: true, fallback: "FP Only" }
  ];

  return (
    <div className="benefits-comparison-table-section my-4">
      <h2 className="table-main-title mb-4">Career Booster Benefits</h2>
      
      <div className="table-responsive rounded-4 overflow-hidden border border-light-subtle shadow-sm">
        <Table responsive className="align-middle m-0 custom-comparison-grid">
          <thead>
            <tr>
              <th className="bg-white col-title-main" style={{ width: '40%' }}>Benefits</th>
              <th className="highlight-column text-center col-title-highlight" style={{ width: '30%' }}>
                Career Booster Combo
              </th>
              <th className="bg-light text-center col-title-secondary" style={{ width: '30%' }}>
                Resume Writing (RW) / <br /> Featured Profile (FW)
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td className="fw-medium text-secondary py-3 ps-3">{row.benefit}</td>
                <td className="highlight-column text-center py-3">
                  {row.combo && <span className="table-green-check">✓</span>}
                </td>
                <td className="bg-light-subtle text-center text-muted small fw-medium py-3">
                  {row.fallback}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default BenefitsTable;